// extracted by mini-css-extract-plugin
module.exports =  {"disabled":"disabled--hDQgB"};